<!--
 * @Descripttion: 
 * @Author: liaoyijun
 * @Date: 2021-08-18 14:43:15
 * @LastEditors: liaoyijun
 * @LastEditTime: 2021-08-18 14:52:10
-->
<template>
    <div class="content">
        <div>
            <img src="../common/images/newsir.gif" alt="" />
            <div class="content-text paddingT10 fontsize-20">努力开发中,敬请期待!</div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    min-height: 340px;
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        display: inline-block;
        width: 82px;
        height: 120px;
    }
    & > div {
        text-align: center;
    }
}
</style>
